import { AlertType, KEY_CODE_ENTER, KEY_CODE_ESCAPE, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import React, { useEffect, useState } from 'react'
import { ProdutoService } from '../../Pages/Products/ProdutoService'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { MdGridOn } from 'react-icons/md'

type Props = {
    visible: boolean
    loading: boolean
    idProd: number
    lancarCodBarras: (codBarraGrade: string, idGrade: number) => void
    closeModalEvent: () => void
}

export const ModalAbrirGradeVenda = React.memo(({ visible, loading, idProd, lancarCodBarras, closeModalEvent }: Props) => {

    const [descProdGrade, setDescProdGrade] = useState("")
    const [produtosList, setProdutosList] = useState<any[]>([])
    const [produtosListCopy, setProdutosListCopy] = useState<any[]>([])
    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(-1)
    const [idGrade, setIdGrade] = useState(0)

    const [codBarras, setCodBarras] = useState("")

    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [loadingGrade, setLoadingGrade] = useState(false)

    useEffect(() => {

        if (visible) {

            getFilter()

            let modal = document.getElementById('modal_abrir_grade_venda')
            let modalContent = document.getElementById('modal_content_abrir_grade_venda')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-36')
                }
            }

        } else {

            setLinhaSelecionada(-1)
            setCodBarras("")
            setDescProdGrade("")
            setVisibleMsg(false)

            let modal = document.getElementById('modal_abrir_grade_venda')
            let modalContent = document.getElementById('modal_content_abrir_grade_venda')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-36')
                }
            }
        }

    }, [visible])

    useEffect(() => {

        if (descProdGrade && descProdGrade.length > 0) {

            const descProdGradeSemAcento = removerAcentos(descProdGrade).toLocaleLowerCase()
            const newProdList = produtosListCopy.filter((item) => {
                const itemSemAcento = removerAcentos(item.variacao.description).toLocaleLowerCase()
                return itemSemAcento.startsWith(descProdGradeSemAcento)
            })

            setProdutosList(newProdList)
            setLinhaSelecionada(-1)
            setCodBarras("")

        } else {

            setLinhaSelecionada(-1)
            setCodBarras("")
            setProdutosList(produtosListCopy)

        }

    }, [produtosListCopy, descProdGrade])

    useEffect(() => {

        const handleKeyDown = (event: any) => {

            if (visible && !loadingGrade  && !loading) {

                const { key } = event

                if (key === 'ArrowUp' || key === 'ArrowDown') {
                    event.preventDefault()

                    let nextIndex
                    if (key === 'ArrowUp') {
                        nextIndex = linhaSelecionada === -1 || linhaSelecionada === 0 ? produtosList.length - 1 : linhaSelecionada - 1
                    } else {
                        nextIndex = linhaSelecionada < produtosList.length - 1 ? linhaSelecionada + 1 : 0
                    }

                    const selectedItem = produtosList[nextIndex]

                    if (selectedItem != undefined) {

                        handleProdGradeSelecionado(selectedItem, nextIndex)
                        setLinhaSelecionada(Math.max(0, Math.min(nextIndex, produtosList.length - 1)))

                        // Scroll into view
                        const element = document.getElementById(`produto-grade-${nextIndex}`)
                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest'
                            })
                        }

                    } else {
                        setLinhaSelecionada(-1)
                        setCodBarras("")
                    }
                }
            }
        }

        const handleKeyPressESC = (event: any) => {

            if (event.code === KEY_CODE_ESCAPE && visible && !loadingGrade  && !loading) {

                closeModalEvent()
            }
        }

        const handleKeyPressEnter = (event: any) => {

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && visible && !loadingGrade  && !loading) {

                Lancar_CodBarras_Grade(codBarras)

            }
        }

        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('keydown', handleKeyPressESC)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('keydown', handleKeyPressESC)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [linhaSelecionada, produtosList, visible, loadingGrade ,loading])

    const getFilter = async () => {

        setLoadingGrade(true)

        try {

            const attributes = await ProdutoService.GetAttributes(idProd?.toString())
            setProdutosList(attributes.data.grade)
            setProdutosListCopy(attributes.data.grade)

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao retornar as grades do produto`)

        } finally {
            setLoadingGrade(false)
            Inputfocus()
        }
    }

    const handleDescProdGrade = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescProdGrade(e.target.value)
    }

    function removerAcentos(s: string) {
        return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    const handleProdGradeSelecionado = (item: any, index: number) => {
        setIdGrade(item.id)
        setCodBarras(item.codBarraRef || item.produto?.cod_barra)
        setLinhaSelecionada(index)
    }

    const Lancar_CodBarras_Grade = (codBarrasGrade: string) => {

        setVisibleMsg(false)

        if (linhaSelecionada !== -1 && lancarCodBarras) {

            lancarCodBarras(codBarrasGrade, idGrade)

        } else {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(`Selecione um produto para o lançamento`)
                clearTimeout(timer)
            }, 250)
        }

    }

    const handleLancarCodBarras = () => {
        Lancar_CodBarras_Grade(codBarras)
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("inputVariacaoGrade")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    return (

        <div id="modal_abrir_grade_venda" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_abrir_grade_venda" className={`relative flex flex-col w-[90%] xl:w-[70%] 2xl:w-[60%] h-[500px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <MdGridOn size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Grade</span>
                </div>

                <div className={`absolute top-[70px] w-full h-full px-3 py-4`}>

                    <div className={`relative w-full`}>
                        <input id="inputVariacaoGrade" className={`${classInput} ${classInputDark} h-[48px] text-[18px]`} type='text' inputMode='text' placeholder='' autoComplete='off' value={descProdGrade} onChange={handleDescProdGrade} />
                        <label htmlFor="inputVariacaoGrade" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Variação</label>
                    </div>

                    <div className={`relative w-full h-[300px] mt-2`}>

                        {loadingGrade &&
                            <div className={`h-full flex justify-center items-center`}>
                                <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                </div>

                            </div>
                        }
                        {!loadingGrade &&
                            <>
                                <div className={`w-full ${produtosList.length > 6 ? `pr-[11px]` : ``}`}>

                                    <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                        <li className={`h-full border-2 border-white dark:border-slate-600`}>

                                            <div className={`w-full flex flex-row h-10 font-mono`}>

                                                <div className={`flex items-center w-[40%] h-full border border-slate-300 dark:border-slate-700`}>
                                                    <span className={`px-2`}>Variação</span>
                                                </div>

                                                <div className={`flex items-center w-[20%] h-full border border-slate-300 dark:border-slate-700`}>
                                                    <span className={`px-2`}>SubVariação</span>
                                                </div>

                                                <div className={`flex items-center w-[20%] h-full border border-slate-300 dark:border-slate-700`}>
                                                    <span className={`px-2`}>Código de Barras</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[20%] h-full border border-slate-300 dark:border-slate-700`}>
                                                    <span className={`px-2`}>Estoque</span>
                                                </div>

                                            </div>
                                        </li>
                                    </ul>

                                </div>

                                <div className={`h-[250px] overflow-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin`}>

                                    <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                        <ul id='elementos' className={`w-full`}>

                                            {produtosList.length > 0 &&
                                                produtosList.map((item, index) => {
                                                    return (

                                                        <li key={item.id} id={`produto-grade-${index}`} onClick={() => handleProdGradeSelecionado(item, index)} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 ${index === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-pointer`}>

                                                            <div className={`w-full flex flex-row h-[38px] font-mono`}>

                                                                <div className={`flex items-center w-[40%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.variacao.description}</span>
                                                                </div>

                                                                <div className={`flex items-center w-[20%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.subVariacao.description}</span>
                                                                </div>

                                                                <div className={`flex items-center w-[20%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.codBarraRef}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[20%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.saldoEstoque}</span>
                                                                </div>

                                                            </div>

                                                        </li>
                                                    )
                                                })
                                            }

                                        </ul>

                                    </div>

                                </div>

                            </>
                        }

                    </div>

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={closeModalEvent}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        onClick={handleLancarCodBarras}
                        className={`${classbtAzul} ${classBt} max-w-[150px] mx-1`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `LANÇAR` : "AGUARDE"}
                    </button>

                </div>

            </div>

        </div>

    )
})